import { MAIN_ROUTER } from 'routers/constants';

export type AppRole = 'admin' | 'user';
export type AppPermission = 'dashboard.view' | 'history.view' | 'csv.export'
  | 'threshold.manage' | 'configuration.manage' | 'mail.manage';

export function getAppRole(userInfo: any): AppRole {
  return userInfo?.appRole === 'admin' ? 'admin' : 'user';
}

export function hasPermission(userInfo: any, permission: AppPermission): boolean {
  if (permission === 'dashboard.view' || permission === 'history.view' || permission === 'csv.export') return true;
  return getAppRole(userInfo) === 'admin';
}

const adminRoutes = new Set<string>([
  MAIN_ROUTER.CATEGORY_MACHINE_TYPE,
  MAIN_ROUTER.CATEGORY_PROTOCOL,
  MAIN_ROUTER.CATEGORY_UNIT,
  MAIN_ROUTER.CATEGORY_DEVICE,
  MAIN_ROUTER.CATEGORY_MAIL_CONFIG,
  MAIN_ROUTER.SYSTEM_USER,
  MAIN_ROUTER.SYSTEM_ROLE
]);

export function canAccessRoute(userInfo: any, path: string): boolean {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return ![...adminRoutes].some(route => pathname === route || pathname.startsWith(`${route}/`))
    || hasPermission(userInfo, 'configuration.manage');
}

// Also guard configuration writes through the shared API client. Read endpoints,
// history filters, CSV exports and personal account changes remain available.
export function canSendRequest(userInfo: any, method: string, url: string): boolean {
  if (['get', 'head', 'options'].includes(method.toLowerCase())) return true;
  const pathname = url.split(/[?#]/)[0];
  const configResource = /(?:^|\/)api\/(?:departments|machines|category-machines|protocols|connection-profiles|tag-definitions|mail-sensor-configs)(?:\/|$)/;
  return !configResource.test(pathname) || hasPermission(userInfo, 'configuration.manage');
}
